import {IEntityDocumentSummary} from './entity-document-summary';
import {EntityDocumentSummary} from './entity-document-summary.class';
import {IOperativeDocumentSummary} from './operative-document-summary.interface';

export class OperativeDocumentSummary extends EntityDocumentSummary implements IOperativeDocumentSummary {
  constructor(iOperativeDocumentSummary?: IOperativeDocumentSummary) {
    super(iOperativeDocumentSummary as IEntityDocumentSummary);
    this.companyId = iOperativeDocumentSummary?.companyId || '00000000-0000-0000-0000-000000000000';
    this.operativeFullName = iOperativeDocumentSummary?.operativeFullName || '';
    this.operativeFirstName = iOperativeDocumentSummary?.operativeFirstName || '';
    this.operativeLastName = iOperativeDocumentSummary?.operativeLastName || '';
    this.operativeId = iOperativeDocumentSummary?.operativeId || '00000000-0000-0000-0000-000000000000';
  }
  companyId: string;
  operativeFullName: string;
  operativeFirstName: string;
  operativeLastName: string;
  operativeId: string;

}
